import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faCheckCircle, faThumbsUp, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SettingsService } from '../shared/services/admin-services/settings.service';
import { Settings } from '../shared/models/admin-models/settings.model';
import { TestingService } from '../shared/testing-email.service';
import { UserService } from '../shared/services/admin-services/user.service';
import { Observable, Subscription } from 'rxjs';
import { OfferNumber } from '../shared/services/admin-services/offer-number.service';
import { Filter } from '../shared/models/filter.model';
import { RoleSendService } from '../shared/services/role-send.service';
import { SendSNOService } from '../shared/services/sno.service';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.sass']
})
export class NavigationBarComponent implements OnInit, OnDestroy {
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  faCheck = faCheck;
  faTimes = faTimes;
  faThumbsUp = faThumbsUp;
  @ViewChild('succesModal', { static: false }) private succesModal;

  @ViewChild('alertModal', { static: false }) private alertModal;
  errorTitle;

  offerNumbers: Observable<OfferNumber[]>;
  roleType: String = '';

  calculator: Boolean = false;
  report: Boolean = false;
  questionnaire: Boolean = false;
  savaNZO: Boolean = false;
  adminPanel: Boolean = false;
  collapsed: Boolean = false;

  userFirstname: String = "";
  // userLastname: String = "";
  successTitle: String = "";

  settingsId: Number;
  settingsForm = new FormGroup({
    SMTPServer: new FormControl('', [Validators.required]),
    SMTPPort: new FormControl('', [Validators.required]),
    SMTPUsername: new FormControl('', [Validators.required]),
    SMTPPassword: new FormControl('', [Validators.required]),
    UseSSL: new FormControl(true, []),
    EmailFrom: new FormControl('', [Validators.required]),
    EmailTest: new FormControl('', []),
    EmailBCC: new FormControl('', []),
    DigitalOfferPremiumRateLimit: new FormControl('', []),
    ProductType: new FormControl('', [Validators.required]),
    Prefix: new FormControl('', [Validators.required]),
    OfferNumberStart: new FormControl('', [Validators.required]),
    OfferNumberEnd: new FormControl('', [Validators.required]),
    Sufix: new FormControl('', [Validators.required]),
    SMSFTPServer: new FormControl('', [Validators.required]),
    SMSFTPUsername: new FormControl('', [Validators.required]),
    SMSFTPPassword: new FormControl('', [Validators.required]),
    VideoIDLink: new FormControl('', [Validators.required]),
    PaymentSlipPayeeName: new FormControl('', [Validators.required]),
    PaymentSlipPayeeAddress: new FormControl('', [Validators.required]),
    PaymentSlipPayeeSettlement: new FormControl('', [Validators.required]),
    PaymentSlipPaymentCode: new FormControl('', [Validators.required]),
    PaymentSlipAccountNumber: new FormControl('', [Validators.required]),
    PlatimatikAccountNumber: new FormControl('', [Validators.required]),
    EURExchangeRate: new FormControl('', [Validators.required]),
    PlatimatikAddress: new FormControl('', [Validators.required]),
    PlatimatikCurrency: new FormControl('', [Validators.required]),
    PlatimatikJMBG: new FormControl('', [Validators.required]),
    PlatimatikName: new FormControl('', [Validators.required]),
    PlatimatikPostalCode: new FormControl('', [Validators.required]),
    PlatimatikSettlement: new FormControl('', [Validators.required]),
    PlatimatikTaxID: new FormControl('', [Validators.required]),
    OfferConfirmedNotificationEmail: new FormControl('', [Validators.required]),
    AgentMustSign: new FormControl(false, []),
    linkPZO: new FormControl(''),
    linkKomDom: new FormControl('')
  })

  savaNZOBool: Boolean = true
  savaNZOForm: FormGroup = new FormGroup({
    email: new FormControl(''),
    mobile: new FormControl('', [Validators.pattern('0[0-9]{7,9}')])
  })

  routeUrl: String = ''
  routerSubscription: Subscription
  innerWidth: Number

  constructor(private router: Router, private modalService: NgbModal, private settingService: SettingsService, private testingService: TestingService, private userService: UserService, private roleSendService: RoleSendService, private sendSNOService: SendSNOService) {
    this.routerSubscription = router.events.subscribe(
      (val: any) => {
        this.routeUrl = val.url
      }
    )
    this.innerWidth = window.innerWidth
  }

  ngOnInit() {
    this.getUser();
    this.getRole();
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe()
  }

  calculatorDropdown(menuNumber) {
    if (menuNumber == 1) {
      this.calculator = !this.calculator;
    } else if (menuNumber == 2) {
      this.report = !this.report;
    } else if (menuNumber == 3) {
      this.questionnaire = !this.questionnaire;
    } else if (menuNumber == 4) {
      this.savaNZO = !this.savaNZO;
    } else {
      this.adminPanel = !this.adminPanel;
    }
  }

  collapsedMenu() {
    this.collapsed = !this.collapsed;
  }

  logout() {
    localStorage.removeItem('token')
    this.router.navigate(['/login'])
  }

  openSettingModal(modal) {
    this.modalService.open(modal, { size: 'xl', backdrop: 'static' });
    this.settingsForm.get('EmailTest').setValue('');
    this.settingsForm.get('EmailBCC').setValue('');
    this.settingService.getSettings()
      .then(
        (x: { id: Number, smtpServer: String, smtpPort: Number, smtpUsername: String, smtpPassword: String, useSSL: Boolean, emailFrom: String, bccEmail: String, digitalOfferPremiumRateLimit: Number, smsftpServer: String, smsftpUsername: String, smsftpPassword: String, videoIDLink: String, paymentSlipPayeeName: String, paymentSlipPayeeAddress: String, paymentSlipPayeeSettlement: String, paymentSlipPaymentCode: String, paymentSlipAccountNumber: String, platimatikAccountNumber: String, platimatikAddress: String, platimatikCurrency: String, platimatikJMBG: String, platimatikName: String, platimatikPostalCode: String, platimatikSettlement: String, platimatikTaxID: String, offerConfirmedNotificationEmail: String, eurExchangeRate: Number, agentMustSign: Boolean, linkToSNOPZO: String, linkToSNOKomDom: String }) => {
          console.log(x)
          this.settingsId = x.id;
          this.settingsForm.get('SMTPServer').setValue(x.smtpServer);
          this.settingsForm.get('SMTPPort').setValue(x.smtpPort);
          this.settingsForm.get('SMTPUsername').setValue(x.smtpUsername);
          this.settingsForm.get('SMTPPassword').setValue(x.smtpPassword);
          this.settingsForm.get('UseSSL').setValue(x.useSSL);
          this.settingsForm.get('EmailFrom').setValue(x.emailFrom);
          this.settingsForm.get('EmailBCC').setValue(x.bccEmail);
          this.settingsForm.get('SMSFTPServer').setValue(x.smsftpServer);
          this.settingsForm.get('SMSFTPUsername').setValue(x.smsftpUsername);
          this.settingsForm.get('SMSFTPPassword').setValue(x.smsftpPassword);
          this.settingsForm.get('DigitalOfferPremiumRateLimit').setValue(x.digitalOfferPremiumRateLimit);
          this.settingsForm.get('VideoIDLink').setValue(x.videoIDLink);
          this.settingsForm.get('PaymentSlipPayeeName').setValue(x.paymentSlipPayeeName);
          this.settingsForm.get('PaymentSlipPayeeAddress').setValue(x.paymentSlipPayeeAddress);
          this.settingsForm.get('PaymentSlipPayeeSettlement').setValue(x.paymentSlipPayeeSettlement);
          this.settingsForm.get('PaymentSlipPaymentCode').setValue(x.paymentSlipPaymentCode);
          this.settingsForm.get('PaymentSlipAccountNumber').setValue(x.paymentSlipAccountNumber);
          this.settingsForm.get('EURExchangeRate').setValue(x.eurExchangeRate);
          this.settingsForm.get('PlatimatikAccountNumber').setValue(x.platimatikAccountNumber);
          this.settingsForm.get('PlatimatikAddress').setValue(x.platimatikAddress);
          this.settingsForm.get('PlatimatikCurrency').setValue(x.platimatikCurrency);
          this.settingsForm.get('PlatimatikJMBG').setValue(x.platimatikJMBG);
          this.settingsForm.get('PlatimatikName').setValue(x.platimatikName);
          this.settingsForm.get('PlatimatikPostalCode').setValue(x.platimatikPostalCode);
          this.settingsForm.get('PlatimatikSettlement').setValue(x.platimatikSettlement);
          this.settingsForm.get('PlatimatikTaxID').setValue(x.platimatikTaxID);
          this.settingsForm.get('OfferConfirmedNotificationEmail').setValue(x.offerConfirmedNotificationEmail);
          this.settingsForm.get('AgentMustSign').setValue(x.agentMustSign);
          this.settingsForm.get('linkPZO').setValue(x.linkToSNOPZO);
          this.settingsForm.get('linkKomDom').setValue(x.linkToSNOKomDom);
        }
      )
    this.getAllOfferNumbers()
  }
  editSettings() {
    // if (!this.settingsForm.invalid) {
    // console.log("Popunjena je")
    let settings = new Settings({ ID: this.settingsId, SMTPServer: this.settingsForm.value.SMTPServer, SMTPPort: parseInt(this.settingsForm.value.SMTPPort), SMTPUsername: this.settingsForm.value.SMTPUsername, SMTPPassword: this.settingsForm.value.SMTPPassword, UseSSL: this.settingsForm.value.UseSSL, EmailFrom: this.settingsForm.value.EmailFrom, BCCEmail: this.settingsForm.value.EmailBCC, DigitalOfferPremiumRateLimit: this.settingsForm.value.DigitalOfferPremiumRateLimit, SMSFTPServer: this.settingsForm.value.SMSFTPServer, SMSFTPUsername: this.settingsForm.value.SMSFTPUsername, SMSFTPPassword: this.settingsForm.value.SMSFTPPassword, VideoIDLink: this.settingsForm.value.VideoIDLink, PaymentSlipPayeeName: this.settingsForm.value.PaymentSlipPayeeName, PaymentSlipPayeeAddress: this.settingsForm.value.PaymentSlipPayeeAddress, PaymentSlipPayeeSettlement: this.settingsForm.value.PaymentSlipPayeeSettlement, PaymentSlipPaymentCode: this.settingsForm.value.PaymentSlipPaymentCode, PaymentSlipAccountNumber: this.settingsForm.value.PaymentSlipAccountNumber, PlatimatikAccountNumber: this.settingsForm.value.PlatimatikAccountNumber, PlatimatikAddress: this.settingsForm.value.PlatimatikAddress, PlatimatikCurrency: this.settingsForm.value.PlatimatikCurrency, PlatimatikJMBG: this.settingsForm.value.PlatimatikJMBG, PlatimatikName: this.settingsForm.value.PlatimatikName, PlatimatikPostalCode: this.settingsForm.value.PlatimatikPostalCode, PlatimatikSettlement: this.settingsForm.value.PlatimatikSettlement, PlatimatikTaxID: this.settingsForm.value.PlatimatikTaxID, OfferConfirmedNotificationEmail: this.settingsForm.value.OfferConfirmedNotificationEmail, EURExchangeRate: this.settingsForm.value.EURExchangeRate, AgentMustSign: this.settingsForm.value.AgentMustSign, LinkToSNOPZO: this.settingsForm.value.linkPZO, LinkToSNOKomDom: this.settingsForm.value.linkKomDom })
    this.settingService.updateSetting(settings)
      .then(
        x => {
          // console.log(x)
          this.modalService.dismissAll();
        }
      )
  }

  openHealthModal(modal) {
    this.savaNZOBool = true
    this.getAllSettings()
    this.savaNZOForm.reset({ email: '', mobile: '' })
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  sendHealth() {
    let mobileRegex = new RegExp('0[0-9]{7,9}')
    if (this.savaNZOForm.value.email != '' || this.savaNZOForm.value.mobile != '') {
      if (this.savaNZOForm.value.email != '' && this.savaNZOForm.value.mobile == '') {
        this.sendSNOService.sendSNOPZO({ Email: this.savaNZOForm.value.email, Mobile: '', SendDestination: 0 })
          .then(
            x => {
              this.modalService.dismissAll()
              this.successTitle = "Uspešno ste poslali link";
              this.modalService.open(this.succesModal, { centered: true })
            },
            e => {
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      } else if (this.savaNZOForm.value.email == '' && this.savaNZOForm.value.mobile != '' && mobileRegex.test(this.savaNZOForm.value.mobile)) {
        this.sendSNOService.sendSNOPZO({ Email: '', Mobile: this.savaNZOForm.value.mobile, SendDestination: 1 })
          .then(
            x => {
              this.modalService.dismissAll()
              this.successTitle = "Uspešno ste poslali link";
              this.modalService.open(this.succesModal, { centered: true })
            },
            e => {
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      } else if (this.savaNZOForm.value.email != '' && this.savaNZOForm.value.mobile != '' && mobileRegex.test(this.savaNZOForm.value.mobile)) {
        this.sendSNOService.sendSNOPZO({ Email: this.savaNZOForm.value.email, Mobile: '', SendDestination: 0 })
          .then(
            x => {
              this.sendSNOService.sendSNOPZO({ Email: '', Mobile: this.savaNZOForm.value.mobile, SendDestination: 1 })
                .then(
                  x => {
                    this.modalService.dismissAll()
                    this.successTitle = "Uspešno ste poslali link";
                    this.modalService.open(this.succesModal, { centered: true })
                  },
                  e => {
                    this.errorTitle = e.error;
                    this.modalService.open(this.alertModal, { centered: true })
                  }
                )
            },
            e => {
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      }
    } else {
      this.errorTitle = "Morate uneti email i/ili mobilni telefon";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }

  openKomDomModal(modal) {
    this.savaNZOBool = false
    this.getAllSettings()
    this.savaNZOForm.reset({ email: '', mobile: '' })
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
  }
  sendKomDom() {
    let mobileRegex = new RegExp('0[0-9]{7,9}')
    if (this.savaNZOForm.value.email != '' || this.savaNZOForm.value.mobile != '') {
      if (this.savaNZOForm.value.email != '' && this.savaNZOForm.value.mobile == '') {
        this.sendSNOService.sendSNOKomDom({ Email: this.savaNZOForm.value.email, Mobile: '', SendDestination: 0 })
          .then(
            x => {
              this.modalService.dismissAll()
              this.successTitle = "Uspešno ste poslali link";
              this.modalService.open(this.succesModal, { centered: true })
            },
            e => {
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      } else if (this.savaNZOForm.value.email == '' && this.savaNZOForm.value.mobile != '' && mobileRegex.test(this.savaNZOForm.value.mobile)) {
        this.sendSNOService.sendSNOKomDom({ Email: '', Mobile: this.savaNZOForm.value.mobile, SendDestination: 1 })
          .then(
            x => {
              this.modalService.dismissAll()
              this.successTitle = "Uspešno ste poslali link";
              this.modalService.open(this.succesModal, { centered: true })
            },
            e => {
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      } else if (this.savaNZOForm.value.email != '' && this.savaNZOForm.value.mobile != '' && mobileRegex.test(this.savaNZOForm.value.mobile)) {
        this.sendSNOService.sendSNOKomDom({ Email: this.savaNZOForm.value.email, Mobile: '', SendDestination: 0 })
          .then(
            x => {
              this.sendSNOService.sendSNOKomDom({ Email: '', Mobile: this.savaNZOForm.value.mobile, SendDestination: 1 })
                .then(
                  x => {
                    this.modalService.dismissAll()
                    this.successTitle = "Uspešno ste poslali link";
                    this.modalService.open(this.succesModal, { centered: true })
                  },
                  e => {
                    this.errorTitle = e.error;
                    this.modalService.open(this.alertModal, { centered: true })
                  }
                )
            },
            e => {
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      }
    } else {
      this.errorTitle = "Morate uneti email i/ili mobilni telefon";
      this.modalService.open(this.alertModal, { centered: true })
    }
    // console.log('Nije uneto nista')
  }

  get validSavaNZOForm() {
    return this.savaNZOForm.controls;
  }


  sentEmail() {
    console.log({ EmailAddress: this.settingsForm.value.EmailTest })
    this.testingService.sendEmail({ EmailAddress: this.settingsForm.value.EmailTest })
      .then(
        x => {
          console.log(x);
          this.successTitle = "Uspešno ste poslali e-mail";
          this.modalService.open(this.succesModal, { centered: true })
          this.settingsForm.get('EmailTest').setValue('')
        }
      )
  }

  getAllOfferNumbers() {
    this.offerNumbers = this.settingService.getOfferNumbers(new Filter({
      Top: null, Page: null, Sort: {
        SortBy: 'ProductType, OfferNumberStart',
        Direction: 0
      }, Filter: {}
    }))
    // this.settingService.getOfferNumbers(new Filter({ Top: null, Page: null, Sort: {}, Filter: {} }))
    //   .subscribe(
    //     (res) => {
    //       console.log(res);
    //     }
    //   )
  }
  editOfferNumber() {
    let offerNum = new OfferNumber({
      ProductType: parseInt(this.settingsForm.value.ProductType),
      Prefix: this.settingsForm.value.Prefix,
      OfferNumberStart: this.settingsForm.value.OfferNumberStart,
      OfferNumberEnd: this.settingsForm.value.OfferNumberEnd,
      Sufix: this.settingsForm.value.Sufix,
      Active: true
    })
    console.log(offerNum)
    this.settingService.updateOfferNumber(offerNum)
      .then(
        x => {
          console.log(x)
          this.getAllOfferNumbers()
          this.settingsForm.get('ProductType').setValue('')
          this.settingsForm.get('Prefix').setValue('')
          this.settingsForm.get('OfferNumberStart').setValue('')
          this.settingsForm.get('OfferNumberEnd').setValue('')
          this.settingsForm.get('Sufix').setValue('')
        }
      )
  }
  activeOfferNumber(id, product, prefix, numberStart, numberEnd, sufix, active) {
    let offerNum = new OfferNumber({
      ID: id,
      Prefix: prefix,
      OfferNumberStart: numberStart,
      OfferNumberEnd: numberEnd,
      Sufix: sufix,
      Active: !active
    })
    if (product == 'Standard')
      offerNum.data.ProductType = 0
    if (product == 'Standard plus')
      offerNum.data.ProductType = 1
    if (product == 'Standard pro')
      offerNum.data.ProductType = 2
    if (product == 'Adut')
      offerNum.data.ProductType = 3
    if (product == 'Sigurnost')
      offerNum.data.ProductType = 4
    if (product == 'Sigurnost plus')
      offerNum.data.ProductType = 5
    if (product == 'Sigurnost kredit')
      offerNum.data.ProductType = 6
    if (product == 'Stipendija')
      offerNum.data.ProductType = 7
    if (product == 'Zlatna jesen')
      offerNum.data.ProductType = 8
    if (product == 'Najlife')
      offerNum.data.ProductType = 9
    if (product == 'Progresiv')
      offerNum.data.ProductType = 11
    if (product == 'Sigurnost keš')
      offerNum.data.ProductType = 12
    if (product == 'Standard VIP')
      offerNum.data.ProductType = 13
    if (product == 'Standard plus VIP')
      offerNum.data.ProductType = 14
    if (product == 'Standard pro VIP')
      offerNum.data.ProductType = 15
    if (product == 'Sigurnost VIP')
      offerNum.data.ProductType = 16
    if (product == 'Sigurnost plus VIP')
      offerNum.data.ProductType = 17
    if (product == 'Stipendija VIP')
      offerNum.data.ProductType = 18
    this.settingService.editOfferNumber(offerNum)
      .then(
        x => {
          // console.log(x)
          this.getAllOfferNumbers()
        }
      )
  }

  snoKomDomLinkFollow: String
  snoPZOLinkFollow: String
  snoCodeFollow: String = ''

  getUser() {
    this.userService.getUser()
      .then(
        (x: { firstname: String, lastname: String, agentSNOCode: string }) => {
          if (x.agentSNOCode) {
            this.snoCodeFollow = btoa(x.agentSNOCode)
          } else {
            this.snoCodeFollow = ''
          }
          // console.log(this.snoCodeFollow)
          // console.log(x.agentSNOCode)

          this.userFirstname = x.firstname + " " + x.lastname;
          // this.userLastname = x.lastname
        }
      )
  }

  getAllSettings() {
    this.settingService.getSettings()
      .then(
        (x: { linkToSNOPZO: String, linkToSNOKomDom: String }) => {
          this.snoPZOLinkFollow = x.linkToSNOPZO
          this.snoKomDomLinkFollow = x.linkToSNOKomDom
          console.log(x)
        },
        e => console.log(e)
      )
  }

  getRole() {
    let jwt = localStorage.getItem('token')!
    let jwtData = jwt.split('.')[1]
    let decodedJwtJsonData = window.atob(jwtData)
    let decodedJwtData = JSON.parse(decodedJwtJsonData)
    this.roleType = decodedJwtData.role

    this.roleSendService.addInfo(this.roleType)
    // this.userService.getRole()
    //   .then(
    //     x => {
    //       // console.log(x)
    //       this.roleType = x[0]
    //       this.roleSendService.addInfo(this.roleType)
    //     }
    //   )
  }

}
